<template>
  <div class="ms ms--intro" :data-id="index">
    <div class="ms__wrap c c--content--pad r r--justify-center r--halign-center pad--h">

      <div class="ms__nav r r--row-always r--justify-space-between r--halign-center">
        <div class="nothing"></div>
        <div class="ms__nav__wrap">
          <!--
          <button
              @click="$emit('close')"
              aria-title="Home"
              class="ms__home icon icon--close">
              <Icon name="icon-home" />
          </button>
          -->
          <button
              @click="$emit('toMenu')"
              aria-title="Topics Menu"
              class="ms__close icon icon--close">
                  <Icon name="close" />
          </button>
        </div>
      </div>

      <div class="ms__content r r--halign-center">
        <div class="ms__icon">
          <IconIntro v-if="type !== 'bonus'" :number="sd.order"/>
          <Icon v-if="type === 'bonus'" :name="`bonus-topic-intro/${sd.slug}`"/>
        </div>
        <div class="ms__content type--align-center">
          <div class="ms__count" v-text="topicTitle"></div>
          <h1 class="ms__title" v-text="lessonTitle"></h1>
        </div>
      </div>
      <div class="ms__buttons r r--halign-center">
        <button v-if="slides.length > 1" class="ms__next btn btn--solid" @click="next">Let's Go!</button>
      </div>
    </div>
    <!--
    <div class="ms__bg"></div>
    -->
  </div>
</template>

<script>
import IconIntro from '@c/IconIntro.vue';
import Icon from "@c/Icon.vue";
export default {
  components: {
    IconIntro,
    Icon,
  },
	props: {
		sd: Object, // aka 'slide data'
    index: Number, // the index of the slide
    slides: Array, // all slide data
    type: String, // module or bonus, etc
	},
  computed: {
    topicTitle() {
      return this.sd.ancestors[0].title;
    },
    lessonTitle() {
      return this.sd.title;
    },
  },
  methods: {
      next() {
          // emit next event to parent
          this.$emit('next', '');
      }
  }
}
</script>

<style lang="scss">
/*
.ms__bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  height: 100vh;
  pointer-events: none;
}
  */
.ms__nav__wrap {
  gap: 20px;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
.ms__bg {
  background-color: var(--color-navy-blue);
}
.ms {
  padding-top: env(safe-area-inset-top);
}
.ms__wrap {
  //padding-top: rem(30px);
}
.ms__title {
  font-size: rem(28px);
  line-height: lh(28px, 32px);
  font-weight: $weight_bold;
  letter-spacing: 0.34px;
  margin-top: rem(5px);
}
.ms__count {
  font-size: rem(14px);
  line-height: lh(14px, 18px);
  font-weight: $weight_bold;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.ms__content {
  margin-top: rem(30px);
}
.ms__buttons {
  margin-top: rem(65px);
}
</style>